import React, { PureComponent } from 'react'
import Paper from 'material-ui-next/Paper'
import RaisedButton from 'material-ui/RaisedButton'
import Book from 'material-ui/svg-icons/action/book'
import Typography from 'material-ui-next/Typography'
import { Link } from 'react-router-dom'
import withStyles from 'material-ui-next/styles/withStyles'

const styles = theme => ({
  ...theme.swapick.styles.infoText,
})

class ComeFare extends PureComponent {
  render() {
    const { classes } = this.props
    return (
      <Paper className={classes.paper}>
        <div>
          <Typography component="h4" className={classes.titles}>
            <Book className={classes.titleIcon} />Come Funziona Swapick?
          </Typography>
          <Typography component="h6" className={classes.subtitles}>
            Swapick trova per te le persone con cui scambiare. Prima però devi dirci che oggetti hai e quali oggetti vuoi!
          </Typography>
          <Typography component="p" className={classes.info} paragraph>
            Ecco come fare:
          </Typography>
          <ol className={classes.info}>
            <li>
              <strong>Aggiungi</strong>
              {' '}
              gli oggetti che possiedi e che vuoi scambiare alla tua
              {' '}
              <span className={classes.positive}>lista possiedo</span>
              . Esplora il magazzino, cerca gli oggetti che vuoi e aggiungili alla tua
              {' '}
              <span className={classes.positive}>lista voglio</span>
              .
            </li>
            <li>
              <strong>Swapick</strong>
              {' '}
              ti mostrerà tutti gli oggetti che potresti ottenere in cambio dei tuoi. Cliccando sugli oggetti potrai avere ulteriori informazioni e costruire la proposta di scambio.
            </li>
            <li>
              Una volta proposto puoi seguire lo stato dello scambio nei tuoi scambi. Swapick ti avviserà non appena la proposta sarà accettata.
            </li>
          </ol>
          <Typography component="p" paragraph className={classes.info}>
            <strong>Cosa aspetti ?</strong>
          </Typography>
          <RaisedButton
            label="Scopri migliaia di oggetti"
            primary={true}
            fullWidth={true}
            containerElement={<Link to="/" />}
          />
        </div>
      </Paper>
    )
  }
}

export default withStyles(styles)(ComeFare)



// WEBPACK FOOTER //
// ./src/common/Infotext/ComeFare.js